import React from 'react';
import { Chip, Box } from '@mui/material';

const EnvironmentIndicator: React.FC = () => {
  // Check if running in Docker
  const isDocker = process.env.REACT_APP_RUNNING_IN_DOCKER === 'true';
  const isDevMode = process.env.NODE_ENV === 'development';

  // Don't show indicator in production unless in Docker
  if (!isDocker && !isDevMode) return null;

  const getEnvironmentInfo = () => {
    if (isDocker) {
      return {
        label: 'DOCKER',
        color: 'primary' as const,
        variant: 'filled' as const
      };
    } else if (isDevMode) {
      return {
        label: 'LOCAL DEV',
        color: 'secondary' as const,
        variant: 'outlined' as const
      };
    }
    return null;
  };

  const envInfo = getEnvironmentInfo();
  if (!envInfo) return null;

  return (
    <Box sx={{ position: 'fixed', top: 8, right: 8, zIndex: 1300 }}>
      <Chip
        label={envInfo.label}
        color={envInfo.color}
        variant={envInfo.variant}
        size="small"
        sx={{
          fontSize: '0.7rem',
          fontWeight: 'bold',
          opacity: 0.8,
          '&:hover': { opacity: 1 }
        }}
      />
    </Box>
  );
};

export default EnvironmentIndicator;
